import { Component, Input, OnDestroy, OnInit } from "@angular/core";

import { debounceTime, distinctUntilChanged, startWith, Subscription } from "rxjs";
import { FormControl } from "@angular/forms";
import { CommunicationService } from "../../services/communication.service";
import { CommunicationContent, Conversation, ConversationRequest, ConversationResponse } from "../../models/communications.model";

@Component({
    selector: 'app-communication-requests',
    templateUrl: './communication-requests.component.html',
    styleUrl: './communication-requests.component.scss',
    standalone: false
})
export class CommunicationRequestsComponent implements OnInit, OnDestroy {
  @Input() isFullScreen!: boolean;

  communicationRequestChats: Conversation[] = [];
  total = 0;

  searchControl = new FormControl<string>('', { nonNullable: true });
  private sub?: Subscription;

  request: ConversationRequest = new ConversationRequest();

  constructor(private communicationSrsService: CommunicationService) {}

  ngOnInit(): void {
    this.sub = this.searchControl.valueChanges.pipe(
      startWith(this.searchControl.value),
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(term => {
      const q = (term ?? '').trim();
      this.request.searchText = q ? q : null;
      this.request.pageNumber = 0;
      this.loadPage();
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  private loadPage(): void {
    this.communicationSrsService.getCommunicationRequestChats(this.request).subscribe({
      next: (resp: ConversationResponse) => {
        this.communicationRequestChats = resp.content ?? [];

        this.total =
          (resp as any).totalElements ??
          (resp as any).total ??
          (resp as any).totalCount ??
          this.communicationRequestChats.length;
      },
      error: err => console.error(err)
    });
  }

  onPageIndexChange(pageIndex: number): void {
    this.request.pageNumber = pageIndex - 1;
    this.loadPage();
  }

  onPageSizeChange(pageSize: number): void {
    this.request.pageSize = pageSize;
    this.request.pageNumber = 0; 
    this.loadPage();
  }

  onGoSubmitRequest(): void {
    this.communicationSrsService.communicationContent = CommunicationContent.SUBMIT_REQUESTS;
  }

  onRequestClick(requestChat: Conversation): void {
    if (!this.isFullScreen) {
      this.communicationSrsService.communicationContent = CommunicationContent.REQUEST_CHAT;
    }
    this.communicationSrsService.selectedRequestChat = requestChat;
  }
}
